export default {
    poweredBy: "Bereitgestellt von"
}